__turbopack_context__.v({
  "chargeback_status": "transactioncard-module-scss-module__FRHZDa__chargeback_status",
  "chargeback_status_closed_child": "transactioncard-module-scss-module__FRHZDa__chargeback_status_closed_child",
  "chargeback_status_closed_parent": "transactioncard-module-scss-module__FRHZDa__chargeback_status_closed_parent",
  "chargeback_status_open_child": "transactioncard-module-scss-module__FRHZDa__chargeback_status_open_child",
  "chargeback_status_open_parent": "transactioncard-module-scss-module__FRHZDa__chargeback_status_open_parent",
  "chargeback_status_under_review_child": "transactioncard-module-scss-module__FRHZDa__chargeback_status_under_review_child",
  "chargeback_status_under_review_parent": "transactioncard-module-scss-module__FRHZDa__chargeback_status_under_review_parent",
  "transctionDate": "transactioncard-module-scss-module__FRHZDa__transctionDate",
  "transctionIcon": "transactioncard-module-scss-module__FRHZDa__transctionIcon",
  "transctionItem": "transactioncard-module-scss-module__FRHZDa__transctionItem",
  "transctionItemGrid": "transactioncard-module-scss-module__FRHZDa__transctionItemGrid",
  "transctionLeftItem": "transactioncard-module-scss-module__FRHZDa__transctionLeftItem",
  "transctionTitle": "transactioncard-module-scss-module__FRHZDa__transctionTitle",
});
